import { Controller } from "stimulus"
import { isEmpty } from "lodash";
import Swal from "sweetalert2";
import StudentService from "../entrypoints/src/admin/services/student-service";

export default class extends Controller {
  connect() {
    this.enrollment = {
      id: this.element.dataset.enrollmentId,
      discountPackage: {}
    }
    this.$emptyMessage = this.element.querySelector('.enrollment-relationship-empty-message');
    this.$tagsInformation = document.querySelectorAll('.student-required-informations');
    this.$requiredRelationMessage = this.element.querySelector('#message-require-specific-relation')
    this.$relationshipMessage = this.element.querySelector('#message-relationship-auto')
    this.$atRelationships = this.element.querySelector('.at-enrollment-relationships');
    this.fetchStudents().then((students) => {
      this.students = students;
      this.updateEnrollments(students);
      this.bindAllEnrollmentRelationships();
    });

    new MutationObserver(() => this.updateEmptyMessage()).observe(this.$atRelationships, { subtree: true, childList: true });

    this.element.querySelector('.new-relationship').addEventListener('click', (ev) => {
      ev.preventDefault();
      setTimeout(() => {
        this.bindingSelect2(this.element.querySelector('.enrollment-relationship:last-child select.select-enrollment-relationship'));
      }, 100);
    });

    $(this.element).on('click', 'a.remove-relationship', (ev) => {
      ev.preventDefault();
      ev.stopPropagation();
      this.removeRelationship(ev.currentTarget);
    });
  }

  updateEnrollments(students) {
    this.selectEnrollments = [];

    if (isEmpty(students))
      return;


    this.selectEnrollments = students.map((student) => {
      if (student.enrollment_id != this.enrollment.id)
        return { id: student.enrollment_id, name: student.name }
    });
  }

  async fetchStudents() {
    if (!this.studentStorageList || this.studentStorageList.length == 0) {
      return await StudentService.all();
    }

    return JSON.parse(this.studentStorageList);
  }

  bindAllEnrollmentRelationships() {
    this.element.querySelectorAll('.enrollment-relationship').forEach((el) => {
      this.bindingSelect2(el.querySelector('select.select-enrollment-relationship'));
    });
  }

  removeRelationship($el) {
    Swal.fire({
      title: 'Atenção',
      html: 'Deseja realmente <b>remover</b> esse relacionamento?',
      showCloseButton: true,
      showCancelButton: true,
      showClass: { backdrop: 'swal2-noanimation', popup: '', },
      hideClass: { popup: '' },
      customClass: {
        cancelButton: 'btn btn-gray-primary',
        confirmButton: 'btn btn-primary mr-3'
      },
      buttonsStyling: false,
      focusConfirm: false,
      confirmButtonText: 'Remover',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.value) {
        this.addHiddenDestroyField($el.closest('.enrollment-relationship'));
        $el.closest('.enrollment-relationship').remove();
      }
    });
  }

  addHiddenDestroyField($el) {
    if (!$el.dataset.objectId)
      return;

    let nodes = `<input type="hidden" name="${$el.dataset.objectName}[_destroy]" value="1" />`;
    $el.closest('.at-enrollment-relationships').insertAdjacentHTML('afterbegin', nodes)
  }

  bindingSelect2(select) {
    $(select).select2({
      language: "pt-BR",
      debug: true,
      allowClear: true,
      data: this.selectEnrollments,
      placeholder: `Buscar por um Aluno (${!!this.students ? `${this.students.length} encontrados` : 'carregando...'})`,
      closeOnSelect: true,
      matcher: this.matchCustom,
      escapeMarkup: function (markup) { return markup; },
      templateResult: function(student) {
        if (student.loading) {
          return student.text;
        }

        return student.name;
      },
      templateSelection: function(student) {
        if (!student.id || !student.name) {
          return student.text;
        }

        return student.name;
      }
    })
    .val(select.dataset.selectedId || 0)
    .trigger('change');
  }

  matchCustom(params, data) {
    if (!data.name)
      return null;

    if ($.trim(params.term) === '' || data.name.toLowerCase().indexOf(params.term.toLowerCase()) > -1) {
      return data;
    }

    return null;
  }

  updateEmptyMessage() {
    let hasAnyRelation = this.element.querySelectorAll('.at-enrollment-relationships .enrollment-relationship').length > 0;
    this.$emptyMessage.classList.toggle('hidden', hasAnyRelation);
    this.$atRelationships.classList.toggle('hidden', !hasAnyRelation);
  }

  updateRelationshipMessage() {
    this.$relationshipMessage.classList.toggle('hidden', (!this.enrollment.discountPackage || isEmpty(this.enrollment.discountPackage.relationships)));
  }

  selectedRelationDegrees() {
    let degrees = [], $selects = this.element.querySelectorAll('.enrollment-relationship-kinship select');

    $selects.forEach(($select) => $select.selectedIndex != -1 && degrees.push($select.options[$select.selectedIndex].dataset.degree));
    let outcomeDegrees = [...document.querySelectorAll('input[name="enrollment-relationship-degree"]')].map((it) => it.value);

    return [...degrees, ...outcomeDegrees];
  }

  resetRelationship() {
    let $selects = this.element.querySelectorAll('.enrollment-relationship-kinship select')

    if ($selects.length == 0)
      return;

    $selects.forEach(($select) => {
      let acceptedRelationships = this.enrollment.discountPackage.relationships;
      if (!isEmpty(acceptedRelationships) && $select.selectedIndex != -1 && !acceptedRelationships.includes($select.options[$select.selectedIndex].dataset.degree)) $select.value = '';
    });
    ([...this.element.querySelectorAll('.enrollment-relationship-kinship select option')]).map((option) => option.removeAttribute('disabled'));
  }

  relationshipValid($enrollRelation) {
    return !isEmpty($enrollRelation.querySelector('select.select-enrollment-relationship').value)
      && !isEmpty($enrollRelation.querySelector('select.select-kinship-degree').value);
  }

  valid() {
    let valid = true;

    this.$requiredRelationMessage.classList.toggle('hidden', valid)
    this.$atRelationships.querySelectorAll('.enrollment-relationship').forEach(($enrollRelation) => valid &= this.relationshipValid($enrollRelation));
    this.$tagsInformation.forEach(($tag) => $tag.classList.toggle('hidden', valid));
    this.updateRelationshipMessage();
    return valid;
  }

  get studentStorageList() {
    return sessionStorage.getItem('students_list');
  }

  set studentStorageList(list) {
    sessionStorage.setItem('students_list', JSON.stringify(list));
  }
}
